import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ✅ GET: Traer todos los movimientos extra de chofer
export const getMovimientoExtraChoferes = async () => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/movimientoextrachofer`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener movimientos extra de chofer",
    };
  }
};

// ✅ POST: Crear nuevo movimiento extra de chofer
export const postMovimientoExtraChofer = async (movimientoData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/movimientoextrachofer`;

  try {
    const resp = await axios.post(url, movimientoData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear movimiento extra de chofer",
    };
  }
};

// ✅ DELETE: Anular / borrado lógico
export const deleteMovimientoExtraChofer = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/movimientoextrachofer/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar movimiento extra de chofer",
    };
  }
};